// Tri-state theme switcher: light / dark / system. Uses lucide icons that
// match the resolved state so the trigger reflects what the user currently
// sees, not what they last picked.
//
// Always renders as an icon-only button — the SidebarFooter wraps it in
// the same `w-12` slot the nav rows use, so the trigger stays on the
// rail's icon column in both collapsed and expanded states. The dropdown
// items themselves are self-labelling ("Light"/"Dark"/"System").

import { Monitor, Moon, Sun } from 'lucide-react';
import { Button } from '../ui/button.js';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu.js';
import { useTheme } from '../../lib/theme.js';

export function ThemeToggle() {
  const { theme, resolvedTheme, setTheme } = useTheme();
  const Icon = resolvedTheme === 'dark' ? Moon : Sun;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        {/* `ring-offset-card` overrides Button's default ring-offset-background
            so the focus ring offsets against the sidebar's L1 surface. */}
        <Button
          variant="ghost"
          size="icon-sm"
          aria-label="Change theme"
          className="ring-offset-card"
        >
          <Icon aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() => {
            setTheme('light');
          }}
          aria-current={theme === 'light' ? 'true' : undefined}
        >
          <Sun className="h-4 w-4" aria-hidden />
          Light
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => {
            setTheme('dark');
          }}
          aria-current={theme === 'dark' ? 'true' : undefined}
        >
          <Moon className="h-4 w-4" aria-hidden />
          Dark
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => {
            setTheme('system');
          }}
          aria-current={theme === 'system' ? 'true' : undefined}
        >
          <Monitor className="h-4 w-4" aria-hidden />
          System
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
